<template>
  <div class="analytics-qlik" v-if="showScreen">
    <v-progress-linear
      indeterminate
      color="trukkin-theme darken-2"
      v-show="loading"
    ></v-progress-linear>
    <div class="analytics-qlik-error" v-if="noTrue">
      Seems like you don't have any permissions. Please contact administrator
    </div>
    <div class="analytics-dash-tabs">
      <button
        type="button"
        v-permissions="'uae-dashboard'"
        v-if="workingCountry.indexOf('UAE') >= 0"
        class="analytics-dash-tab"
        :class="{
          'analytics-dash-tab--active': link === links.UaeSalesDashboard,
        }"
        @click="
          redirect(links.UaeSalesDashboard, 'uae-dashboard', 'Inquiry Details')
        "
      >
        UAE Sales dashboard
      </button>
      <button
        type="button"
        v-permissions="'pak-dashboard'"
        v-if="workingCountry.indexOf('PAK') >= 0"
        class="analytics-dash-tab"
        :class="{
          'analytics-dash-tab--active': link === links.PakSalesDashboard,
        }"
        @click="
          redirect(links.PakSalesDashboard, 'pak-dashboard', 'Inquiry Details')
        "
      >
        PAK Sales dashboard
      </button>
      <button
        type="button"
        v-permissions="'ksa-dashboard'"
        v-if="workingCountry.indexOf('KSA') >= 0"
        class="analytics-dash-tab"
        :class="{
          'analytics-dash-tab--active': link === links.KsaSalesDashboard,
        }"
        @click="
          redirect(links.KsaSalesDashboard, 'ksa-dashboard', 'Inquiry Details')
        "
      >
        KSA Sales dashboard
      </button>
      <button
        type="button"
        v-permissions="'pod-dashboard'"
        class="analytics-dash-tab"
        :class="{ 'analytics-dash-tab--active': link === links.PodDashboard }"
        @click="redirect(links.PodDashboard, 'pod-dashboard', 'Inquiry Details')"
      >
        POD Dashboard
      </button>
      <button
        type="button"
        v-if="
          workingCountry.indexOf('UAE') >= 0 ||
          workingCountry.indexOf('KSA') >= 0
        "
        v-permissions="'complete-assignment-level-report'"
        class="analytics-dash-tab"
        :class="{
          'analytics-dash-tab--active':
            link === links.completeAssignmentLevelReport,
        }"
        @click="
          redirect(
            links.completeAssignmentLevelReport,
            'complete-assignment-level-report',
            'Inquiry Details'
          )
        "
      >
        Complete assignment level report
      </button>
    </div>
    <div class="analytics-dash-frame" v-if="link">
      <iframe
        target="_blank"
        name="frame"
        :src="this.link"
      ></iframe>
    </div>
    <success-dialog
      content="Customer Edited successful"
      :show="x.registerSuccess"
      :onclose="closeRegistration"
    />
    <v-snackbar
      :timeout="3000"
      color="red darken-2"
      v-model="x.error"
      class="white--text"
      v-if="x.error"
      >{{ x.error }}</v-snackbar
    >
  </div>
</template>

<script>
import SuccessDialog from "@/components/Common/SuccessDialog";
import { EventBus } from "../../event-bus.js";
import checkPermissionsMixin from "@/mixins/checkPermissionsMixin";
import { StorageKeys, JobListTypes } from "../../constants/constants";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  mixins: [checkPermissionsMixin],
  components: {
    SuccessDialog,
  },

  created() {
    function login() {
      console.log();
      function isLoggedIn() {
        return fetch(
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/api/v1/users/me",
          {
            method: "GET",
            mode: "cors",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "qlik-web-integration-id": "QXvSbZZj8JH5lav4PxKwgBAxaR2F2M5Y",
            },
          }
        ).then((response) => {
          return response.status === 200;
        });
      }
      return isLoggedIn().then((loggedIn) => {
        if (!loggedIn) {
          const webIntegrationId = "QXvSbZZj8JH5lav4PxKwgBAxaR2F2M5Y";
          console.log(webIntegrationId);
          // check login
          window.location.href =
            "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/login?qlik-web-integration-id=" +
            webIntegrationId +
            "&returnto=" +
            top.location.href;

          // window.location.href =
          //   "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/login?qlik-web-integration-id=" +
          //   + "QXvSbZZj8JH5lav4PxKwgBAxaR2F2M5Y" + "&returnto=" + top.location.href;
          throw new Error("not logged in");
        }
      });
    }
    login();

    this.$eventBus.$emit("off-load");
    if (localStorage.getItem("workingCountries")) {
      let workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = workingCountry;
      this.checkRoles();
    }
    EventBus.$on("countryChanged", (val) => {
      this.loading = false;
      this.link = "";
      this.istrue = false;

      this.workingCountry = val;

      if (this.currentTab == "redash")
        if (this.$route.name == "analytics") {
          this.checkRoles();
        }
    });

    // this.redirect(
    //   this.links.KsaSalesDashboard,
    //   "ksa-dashboard",
    //   "Inquiry Details"
    // );
  },
  props: {
    currentTab: String,
  },

  data() {
    return {
      noTrue: false,
      configJwt: "",
      creditLimit: "",
      loading: false,
      link: "",
      showScreen: true,

      links: {
        // jobsNoSalesInvoice:
        //   "https://analytics.trukkin.com/public/dashboards/uyDJKketBJnX2JdL8nFb6jNuUPDVRcifWbjOWVeo?org_slug=default&refresh=60",
        // InquiryDetails:
        //   "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/single/?appid=b4768ee0-d32c-4f5f-a3fc-31a8b3d212a0&sheet=ba1e13db-8c3e-4e94-bb02-ebfa0a450f56&theme=card&opt=ctxmenu,currsel",

        KsaSalesDashboard:
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/sense/app/5e8488d7-6551-45c0-817c-6275f535b682/sheet/6d7811f7-3e76-46c2-b161-c019c6a401f2/state/analysis/hubUrl/%2Fexplore%2Fspaces%2Fall",
        completeAssignmentLevelReport:
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/single/?appid=8e184148-e6ae-4569-a1a9-48024a54340b&sheet=9f630425-5fc4-4411-9fa1-153134347a3e&theme=breeze&opt=ctxmenu,currsel",

        UaeSalesDashboard:
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/sense/app/5e8488d7-6551-45c0-817c-6275f535b682/sheet/c3a490b3-c7c0-421a-87ea-fd2007dd20f4/state/analysis/hubUrl/%2Fexplore%2Fspaces%2Fall",
        PakSalesDashboard:
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/sense/app/5e8488d7-6551-45c0-817c-6275f535b682/sheet/cdb2bd2b-94b1-4af0-8495-bba5416592b3/state/analysis/hubUrl/%2Fexplore%2Fspaces%2Fall",

        OperationsDashboard:
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/single/?appid=b4aaad38-8bb7-47a6-84ba-74c60b9869bb&sheet=9f630425-5fc4-4411-9fa1-153134347a3e&theme=breeze&opt=ctxmenu,currsel&select=clearall",
        CustomerRevenue:
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/single/?appid=d971516d-2a35-408c-819b-2b0868d245ee&sheet=80d023c6-558e-4769-9161-3ebe9b9fd87b&theme=breeze&opt=ctxmenu,currsel",
        PodDashboard:
          "https://lpe4xujzdwnh1g1.sg.qlikcloud.com/sense/app/5e8488d7-6551-45c0-817c-6275f535b682/sheet/2b0c82f9-f66f-4d6b-89ae-3242215819ad/state/analysis/hubUrl/%2Fexplore%2Fspaces%2Fall",
      },
      invoiceDay: "",
      defaultId: "",
      loading: false,
      readonly: true,
      currency: "",
      edit: true,
      creditLimit: "",
      time: "",
      multipleCountry: "",
      countryCodes: [],
      invoicingCity: null,
      workingCountry: "",
      invoicingCountry: "",
      valid: true,
      lazy: false,
      model: [],
      processing: false,
      componentKey: 0,
      search: "",
      loading: false,
      isNoSearchResult: false,

      x: {
        loading: false,
        registerSuccess: false,
        menu: false,
        dateOfBirth: null,
        error: null,
        missingField: null,
      },
      rules: {
        required: (value) => !!value || "This field is required.",
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "Enter valid value.",
        emailRules: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "E-mail must be valid",
        countryCode: (v) =>
          /^(\+?\d{1,3}|\d{1,4})$/.test(v) ||
          "Please Enter Valid Country Code.",
        // phoneNumber: (v) =>
        //   /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(v) ||
        //   "Please Enter Valid Phone No.",
        phoneNumber: (v) =>
          /^[0-9]{5,15}$/.test(v) || "Please Enter Valid Phone No.",
        counter: (value) =>
          (value != null && value.trim().length <= 20) ||
          "Number should contain maximum 20 characters.",
        vatNumber: (v) =>
          /^([a-zA-Z0-9_-]){1,20}$/.test(v) || "Please Enter Valid Value",
        requiredLocation: (value) =>
          (!!value && !!value.length) || "This field is required.",
        number: (v) => /^[0-9]*$/.test(v) || "Please enter valid amount",
      },
    };
  },
  computed: {
    haserror() {
      return this.x.error !== null;
    },
  },

  watch: {},

  methods: {
    loginqlik() {
      return fetch(
        "https://" + "lpe4xujzdwnh1g1.sg.qlikcloud.com" + "/login/jwt-session",
        {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "qlik-web-integration-id": "QXvSbZZj8JH5lav4PxKwgBAxaR2F2M5Y",
            Authorization: "Bearer " + this.configJwt,
          },
        }
      ).then((response) => {
        console.log(response);
        if (response.status !== 200) {
          throw new Error("failed to login via jwt");
        }
      });
    },
    fetchQlikSense() {
      let url = `/dmsAdmin/qlick-token`;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios
        .get(
          this.constants.apiUrl + url,

          config
        )
        .then(
          (response) => {
            console.log(response.data.data.token);
            this.configJwt = response.data.data.token;
            this.loginqlik();
          },
          (error) => {
            // this.x.error = "Failed to Fetch User Details";
          }
        );
    },
    checkRoles() {
      // this.noTrue = false;
      let userPermissions = JSON.parse(
        localStorage.getItem("permissions")
      ).permissions;
      let redash = {};
      let subRoles = {};

      console.log(this.workingCountry);
      console.log(this.workingCountry.indexOf("KSA"));
      if (this.workingCountry.indexOf("KSA") >= 0) {
        subRoles["ksa-dashboard"] = "KsaSalesDashboard";
        subRoles["complete-assignment-level-report"] =
          "completeAssignmentLevelReport";
      }
      if (this.workingCountry.indexOf("UAE") >= 0) {
        subRoles["uae-dashboard"] = "UaeSalesDashboard";
        subRoles["complete-assignment-level-report"] =
          "completeAssignmentLevelReport";
      }
      if (this.workingCountry.indexOf("PAK") >= 0) {
        // subRoles["inquiries-details"] = "InquiryDetails";
        subRoles["pak-dashboard"] = "PakSalesDashboard";
      }
      subRoles["pod-dashboard"] = "PodDashboard";
      redash = subRoles;
      console.log(subRoles);
      let role = JSON.parse(localStorage.getItem("permissions")).roles;
      for (var i = 0; i < userPermissions.length; i++) {
        if (redash[userPermissions[i].operationName]) {
          console.log(redash[userPermissions[i].operationName]);
          this.noTrue = false;
          this.link = this.links[redash[userPermissions[i].operationName]];
          break;
        } else {
          this.noTrue = true;
        }
      }

      role.filter((x) => {
        if (x.role.roleName == "redash") {
          if (!x.operations.length) {
            this.noTrue = true;
          }
        }
      });
    },
    async checkButtonPermissions(subRole) {
      this.loading = true;
      this.operationName = subRoles;
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
      } else {
        return;
      }
    },
    async checkSave() {
      this.operationName = "edit-default-limit";
      this.loading = true;
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
        this.editDefaults();
      } else {
        return;
      }
    },
    redirectTo(linked) {
      this.link = linked;
    },

    async redirect(linked, role, event) {
      this.loading = true;
      this.operationName = role;
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
        // this.track(event, {
        //   $email: localStorage.getItem("email"),
        //   $name: localStorage.getItem("user"),
        //   WorkingCountry: localStorage.getItem("workingCountry"),
        // });

        this.link = linked;
      } else {
        return;
      }
    },
    close() {
      this.$router.go(-1);
    },

    closeRegistration() {
      this.registerSuccess = false;
      this.$router.go(-1);
    },

    getTime(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getTime2(date) {
      return moment.utc(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
.errorbox,
.analytics-qlik-error {
  color: var(--oms-red, #be3b32);
  font-size: 0.875rem;
  font-weight: 600;
  padding: 1.25rem;
  text-align: center;
}
</style>

<style>
#nav .analytics-qlik {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 0 0 1rem;
}

#nav .analytics-dash-tabs {
  align-items: center;
  background: #edebe5;
  border-radius: 0.6875rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin: 1rem 1.25rem 0;
  padding: 0.25rem;
  width: fit-content;
  max-width: calc(100% - 2.5rem);
}

#nav .analytics-dash-tab,
#nav .analytics-page .analytics-dash-tab {
  align-items: center;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: var(--oms-muted, #74716a) !important;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: auto !important;
  justify-content: center;
  letter-spacing: 0 !important;
  min-height: 1.875rem !important;
  min-width: 0 !important;
  padding: 0.4375rem 0.75rem !important;
  text-transform: none !important;
  white-space: nowrap;
}

#nav .analytics-dash-tab--active,
#nav .analytics-page .analytics-dash-tab--active {
  background: #ffffff !important;
  box-shadow: 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.13) !important;
  color: var(--oms-ink-strong, #1a1916) !important;
}

#nav .analytics-dash-tab:hover,
#nav .analytics-page .analytics-dash-tab:hover {
  color: var(--oms-ink-strong, #1a1916) !important;
}

#nav .analytics-dash-frame {
  background: #ffffff;
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.75rem;
  margin: 1rem 1.25rem 0;
  min-height: 42rem;
  overflow: hidden;
}

#nav .analytics-dash-frame iframe {
  background: #ffffff;
  border: 0;
  display: block;
  height: 70vh;
  min-height: 42rem;
  width: 100%;
}

html.oms-night-mode #nav .analytics-dash-tabs {
  background: var(--oms-surface-soft, #2a2925) !important;
}

html.oms-night-mode #nav .analytics-dash-tab {
  color: var(--oms-muted) !important;
}

html.oms-night-mode #nav .analytics-dash-tab--active {
  background: var(--oms-surface) !important;
  color: var(--oms-ink-strong) !important;
}
</style>
